/**
 * Player identity helpers — every New Game gets a fresh random name +
 * id that the scoreboard files the run under.
 */

const ADJECTIVES = [
  'Glowing', 'Drifting', 'Hungry', 'Tiny', 'Brave', 'Swift', 'Silent',
  'Curious', 'Spiny', 'Twitchy', 'Lucky', 'Restless', 'Violet', 'Amber',
  'Cobalt', 'Crimson', 'Wobbly', 'Sneaky', 'Ancient', 'Radiant',
];

const ORGANISMS = [
  'Amoeba', 'Diatom', 'Rotifer', 'Paramecium', 'Volvox', 'Euglena',
  'Tardigrade', 'Ciliate', 'Spore', 'Plankton', 'Microbe', 'Flagellate',
  'Radiolarian', 'Hydra', 'Foraminifera', 'Stentor',
];

function pick<T>(list: T[]): T {
  return list[Math.floor(Math.random() * list.length)];
}

export function randomPlayerName(): string {
  return `${pick(ADJECTIVES)} ${pick(ORGANISMS)} ${100 + Math.floor(Math.random() * 900)}`;
}

/** UUID v4. crypto.randomUUID is missing on plain-http LAN dev, so fall back. */
export function randomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
